export const DASHBOARD_SECTIONS: any = {
    LOCATION_DETAILS: 'locationDetails',
    CONTACT_DETAILS: 'contactDetails',
    PLACARD_DETAILS: 'placardDetails',
    PICKUP_DETAILS: 'pickupDetails',
    NOTIFICATIONS: 'notifications',
    PLACARD_VERIFICATION: 'placardVerification',
    PLACARD_LOCATION: 'placardLocation',
    VERIFICATION_NEEDED: 'verificationNeeded'
};

export const PLACARD_STATUS: any = {
    DEFAULT: "TEST",
    EXPIRED_2: "Expired 2",
    CANCELLED: 'Cancelled',
    EXPIRED: 'Expired',
    REJECTED: 'Rejected',
    AGED: 'Aged',
    DISPATCHED: 'Dispatched',
    CREATED: 'Created',
    CREATED_1: 'Created 1',
    CREATED_2: 'Created 2',
    CANCELLED_NO_HUNG: 'CANCELLED_NO_HUNG',
    PENDING: 'Pending',
    ACTIVE: 'Active'
};

export const SECTIONS_BY_STATUS: any[] = [
    {
        status: PLACARD_STATUS.EXPIRED_2,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.PLACARD_VERIFICATION,
        DASHBOARD_SECTIONS.PLACARD_LOCATION,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED
        ]
    },
    {
        status: PLACARD_STATUS.EXPIRED,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED
        ]
    },
    {
        status: PLACARD_STATUS.CANCELLED,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.PLACARD_VERIFICATION,
        DASHBOARD_SECTIONS.PLACARD_LOCATION]
    },
    {
        status: PLACARD_STATUS.CREATED,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED]
    },
    {
        status: PLACARD_STATUS.CREATED_1,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED]
    },
    {
        status: PLACARD_STATUS.CREATED_2,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.PLACARD_VERIFICATION,
        DASHBOARD_SECTIONS.PLACARD_LOCATION,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED]
    },
    {
        status: PLACARD_STATUS.PENDING,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.PLACARD_VERIFICATION,
        DASHBOARD_SECTIONS.PLACARD_LOCATION,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED]
    },
    {
        status: PLACARD_STATUS.ACTIVE,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.PLACARD_VERIFICATION,
        DASHBOARD_SECTIONS.PLACARD_LOCATION,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED]
    },
    {
        status: PLACARD_STATUS.DISPATCHED,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.PLACARD_VERIFICATION,
        DASHBOARD_SECTIONS.PLACARD_LOCATION,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED]
    },
    {
        status: PLACARD_STATUS.REJECTED,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.PLACARD_VERIFICATION,
        DASHBOARD_SECTIONS.PLACARD_LOCATION,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED
        ]
    },
    {
        status: PLACARD_STATUS.AGED,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS,
        DASHBOARD_SECTIONS.PLACARD_VERIFICATION,
        DASHBOARD_SECTIONS.PLACARD_LOCATION,
        DASHBOARD_SECTIONS.VERIFICATION_NEEDED
        ]
    },
    {
        status: PLACARD_STATUS.CANCELLED_NO_HUNG,
        sections: [DASHBOARD_SECTIONS.LOCATION_DETAILS,
        DASHBOARD_SECTIONS.CONTACT_DETAILS,
        DASHBOARD_SECTIONS.PLACARD_DETAILS,
        DASHBOARD_SECTIONS.PICKUP_DETAILS,
        DASHBOARD_SECTIONS.NOTIFICATIONS
        ]
    }
];

export const LANGUAGES_COUNTRIES_LOCALES = [
    { locale: "en_US", value: "en_US", countryCode: 'US', language: 'upplm.common.english', showTemporaryPlacard: true},
    { locale: "en_CA", value: "en_CA", countryCode: 'CA', language: 'upplm.common.english', showTemporaryPlacard: true },
    { locale: "fr_CA", value: "fr_CA", countryCode: 'CA', language: 'upplm.common.french', showTemporaryPlacard: true },
    { locale: "de_DE", value: "de_DE", countryCode: 'DE', language: 'upplm.common.deutsch', showTemporaryPlacard: true },
    { locale: "it_IT", value: "it_IT", countryCode: 'IT', language: 'upplm.common.italian', showTemporaryPlacard: true },
    { locale: "fr_FR", value: "fr_FR", countryCode: 'FR', language: 'upplm.common.french', showTemporaryPlacard: true},
    { locale: "en_GB", value: "en_GB", countryCode: 'GB', language: 'upplm.common.english', showTemporaryPlacard: true },
    { locale: "es_ES", value: "es_ES", countryCode: 'ES', language: 'upplm.common.spanish', showTemporaryPlacard: true },
    { locale: "en_FR", value: "en_FR", countryCode: 'FR', language: 'upplm.common.english', showTemporaryPlacard: false },
    { locale: "en_IT", value: "en_IT", countryCode: 'IT', language: 'upplm.common.english', showTemporaryPlacard: false },
    { locale: "en_DE", value: "en_DE", countryCode: 'DE', language: 'upplm.common.english', showTemporaryPlacard: false },
    { locale: "en_ES", value: "en_ES", countryCode: 'ES', language: 'upplm.common.english', showTemporaryPlacard: false },
];